'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './invited-user-list.routes';

export class InvitedUserListComponent {
  constructor(InvitedUserService, dialogs, Auth, $stateParams) {
    'ngInject';

    this.InvitedUserService = InvitedUserService;
    this.users = InvitedUserService.query();
    this.dialogs = dialogs;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;

    this.type = $stateParams.type;
  }

  block(user) {
    var that = this;
    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Block Request", "Do you really want to block this request and thus delete this prospective user?" + userStr);
    dlg.result.then(() => {
      /* Delete the user */
      that.InvitedUserService.delete({id: user._id},
        () => {
          that.users = that.users.filter(function( obj ) {
            return obj._id !== user._id;
          });
        },
        err => {
          alert("Could not delete document");
        });
    }, () => {
      // Cancel
    });
  }

  approve(user) {
    var that = this;
    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Approve Request", "Do you want to approve this request?" + userStr);
    dlg.result.then(() => {
      that.InvitedUserService.approve({id: user._id}, {},
        () => {
          that.dialogs.notify("The Request has been approved.",
            "The prospective user will receive an email with the instructions on how to activate the account.");
          that.users = that.InvitedUserService.query();
        },
        err => {
          alert("Could not approve account");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduu.ap.admin.invitedUserList', [uiRouter])
  .config(routes)
  .component('invitedUserList', {
    template: require('./invited-user-list.html'),
    controller: InvitedUserListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/admin/invited-user-list/invited-user-list.component.js